import PropTypes from "prop-types";

export const AccentMint = ({ children }) => {
  return <span className="accent-mint">{children}</span>;
};

AccentMint.propTypes = {
  children: PropTypes.node,
};
